import { AfterViewInit, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { getCrateTypeName } from 'src/app/helpers/format-crate-type';
import { translateState } from 'src/models/Crate';
import { Pallet } from '../../stock-levels-model/stock-levels-modal.component';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-package-list-details',
  templateUrl: './package-list-details.component.html',
  styleUrls: ['./package-list-details.component.scss']
})
export class PackageListDetailsComponent implements OnInit, AfterViewInit {
  @Input() packages: Pallet[] = [];
  @Input() palletToScrollTo: string | null = null;
  @Output() goToPalletDetails = new EventEmitter();

  constructor(private zone: NgZone) { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.zone.onStable.pipe(take(1)).subscribe(() => {
      const el = document.getElementById(this.palletToScrollTo!);
      el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.palletToScrollTo = null;
    });
  }

  openPalletDetails(pallet: Pallet) {
    this.goToPalletDetails.emit(pallet);
  }

  formatType(type) {
    return getCrateTypeName(type);
  }

  translatePalletState(state) {
    return translateState(state);
  }

}
